module.exports = __webpack_public_path__ + "27e1814b20b8651f6ffc163c9f54a5e5.otf";